import { EnterpriseContractPoliciesV1NaptimeResource } from './__generated__/EnterpriseContractPoliciesV1';

class EnterpriseContractPoliciesV1 extends EnterpriseContractPoliciesV1NaptimeResource {
  static RESOURCE_NAME = 'enterpriseContractPolicies.v1' as const;
}

export default EnterpriseContractPoliciesV1;
